import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { HeaderLogoSvg } from "../Components/Svgs";
import Button from "../Components/Common/FormElements/Button/Button";
import PassswordInput from "../Components/Common/Forms/ResetPassword/PassswordInput";
import { closeError } from "../REDUX/actions/error";
import { resetPasswordCode } from "../REDUX/actions/user";
import { useNavigate } from "react-router-dom";

function ResetPasswordCode() {
  const { t } = useTranslation("common");

  const [newPassword, setnewPassword] = useState();
  const [newConfirmPassword, setnewConfirmPassword] = useState();
  const [errMessage, seterrMessage] = useState();

  const userData = useSelector((state) => state.userReducer);

  const urlParams = new URLSearchParams(window.location.search);
  const resetCode = urlParams.get("code");
  const userId = urlParams.get("id");

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const handleChangeNewPassword = (e) => {
    dispatch(closeError());
    setnewPassword(e.target.value);
  };
  const handleChangeConfirmPassword = (e) => {
    dispatch(closeError());
    setnewConfirmPassword(e.target.value);
  };

  useEffect(() => {
    if (
      (newPassword && newPassword?.length < 6) ||
      (newConfirmPassword && newConfirmPassword?.length < 6) ||
      newPassword !== newConfirmPassword
    ) {
      seterrMessage(true);
    } else seterrMessage(false);
  }, [newPassword, newConfirmPassword]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      resetPasswordCode({
        userId,
        resetCode,
        newPassword,
        newConfirmPassword,
        navigate,
      }),
    );
  };

  return (
    <div className="bg-blue vh100 d-flex justify-content-center align-items-center">
      <form className="loginForm bg-white br5 d-flex flex-column justify-content-center align-items-center">
        <HeaderLogoSvg
          textColor="blue"
          imageURL="poseidon-login-logo-blue.png"
        />
        <div className="mt-4 w60">
          <PassswordInput
            text={t("New password")}
            withoutPlaceHolder
            value={newPassword}
            callback={handleChangeNewPassword}
          />
          <PassswordInput
            text={t("Confirm password")}
            withoutPlaceHolder
            value={newConfirmPassword}
            callback={handleChangeConfirmPassword}
          />
          {(newPassword?.length < 6 || newConfirmPassword?.length < 6) && (
            <span className="text-red f12 ">
              {t("Please enter a password with at least 6 characters!")}
            </span>
          )}
          {newPassword !== newConfirmPassword && (
            <p className="text-red f12 mb-0">
              {t("The new password and password confirmation do not match!")}
            </p>
          )}

          <p className="text-red f12 mb-0">{errMessage}</p>
        </div>

        <Button
          loading={userData.userLoading || userData?.resetPwdLoading}
          className="mt-3"
          onClick={handleSubmit}
          isSubmit={true}
          disabled={!newPassword || !newConfirmPassword || errMessage}
        >
          {t("Reset my password")}
        </Button>
      </form>
    </div>
  );
}

export default ResetPasswordCode;
